/**
 * Series legend.
 *
 * Always present for two or more series: identity must never rest on colour alone,
 * which matters more here than usual because the token palette only clears all-pairs
 * CVD separation for its first three slots (see `lib/chart-palette.ts`).
 */

export interface LegendEntry {
  key: string;
  label: string;
  colour: string;
  /** Optional right-hand figure, already formatted. */
  value?: string;
}

export function ChartLegend({ entries }: { entries: readonly LegendEntry[] }) {
  if (entries.length === 0) return null;
  return (
    <ul className="chart-legend">
      {entries.map((entry) => (
        <li key={entry.key} className="chart-legend-item">
          <span className="chart-legend-swatch" style={{ background: entry.colour }} aria-hidden="true" />
          <span className="chart-legend-label truncate" title={entry.label}>
            {entry.label}
          </span>
          {entry.value ? <span className="chart-legend-value num">{entry.value}</span> : null}
        </li>
      ))}
    </ul>
  );
}
